<template>
	<div class="details">
		<div class="container">
			<div class="row">
				<form action="#" method="post" @submit.prevent="submit" class="col-md-9 mx-auto">
					<div class="form-box review-box">
						<img src="./../../assets/finish.jpg" alt="Finish" class="envelope-icon">
						<h1>Verify Your Account</h1>
						<p>Hi <strong>{{ firstName }}</strong>, we've sent a 6-digit code to <strong>{{ email }}</strong>.<br>Please check your email and let's finish setting things up for you!</p>
						<div class="form-field verification-code mt-4 mb-5">
							<input type="text" maxlength="6" minlength="6" placeholder="------" class="form-control form-control-code" name="code" v-model="code" :disabled="verification">
							<button type="submit" class="btn btn-primary" :disabled="sending || verification">
								<span class="spinner-border" v-if="sending || verification"></span>
								<span v-if="!sending && !verification">Verify Account</span>
							</button>
							<p class="text-danger fw-bolder small mt-3 mb-0" v-if="error">Invalid code. Please try again.</p>
						</div>
						<div class="d-flex align-items-center justify-content-center">
							<p class="small">Didn't receive email?</p>
							<button type="button" @click.prevent="sendVerificationCode" class="btn btn-link p-0 ms-2" :disabled="sending || (!sending && !allowResend)">Resend Email</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import repository from "@/repository/repository";
import Logs from "@/repository/logs";

export default {
    name: "ReviewForm",
    beforeMount() {
        // Verify the previous step is completed
        if(!this.$store.getters.agreements.completed) {
            this.$router.replace("/details/agreements");
        }

        // Verify if the current step is finished
        if(this.$store.getters.review.finished) {
            this.$router.replace("/already-completed");
        }
    },
	created() {
        // Send the verification email after 1 second
        let app = this;
        setTimeout(function () {
            app.sendVerificationCode();
		}, 1000);
    },
    data() {
        return {
            firstName: this.$store.getters.personal.firstName,
            email: this.$store.getters.auth.email,
			code: null,
			allowResend: false,
			sending: false,
			verification: false,
			error: null,
		}
	},
	methods: {
        sendVerificationCode() {
            this.sending = true;
            this.allowResend = false;
            repository.get("/verify")
				.then(() => {
					this.sending = false;
                    let app = this;
                    setTimeout(function () {
                        app.allowResend = true;
					}, 15000);
				})
		},
        submit() {
            if(!this.verifyCode()) {
                this.error = "invalid_code";
                return;
			}
            this.verification = true;
            let payload = {
                code: this.code,
            };
            repository.post("/verify", payload)
				.then(response => {
                    console.log(response);
                    this.verification = false;
                    this.$store.commit("finishReview");
                    this.$router.push("/completed");
                    this.$gtag.event('onboarding_completed', {
						// amount: this.$store.getters.investment.initialAmount,
						value: this.$store.getters.investment.initialAmount,
					});
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'onboarding_completed',
                        'value': this.$store.getters.investment.initialAmount,
                    });
				})
				.catch(error => {
                    this.verification = false;
                    this.error = error.response.data.code;
                    Logs.save('onboarding.reviewForm', error.response, payload);
				})
		},
		verifyCode() {
            return /^[0-9]{6}$/.test(this.code);
		},
	},
}
</script>

<style lang="scss">
.form-box.review-box {
	text-align: center;
	padding: 7.5rem 7.5rem;

	@media (max-width: 767px) {
		padding: 2.5rem 0;
	}

	.envelope-icon {
		width: 100px;
	}

	h1 {
		font-weight: 600;
		color: #16193a;
		font-size: 2rem;
		margin: 2rem 0 1rem 0;

		strong {
			font-weight: 600;
		}

		@media (max-width: 767px) {
			font-size: 2rem;
		}
	}

	p {
		font-size: 1.2rem;
		font-weight: 400;
		color: #144069;
		margin: 0;

		@media (max-width: 767px) {
			font-size: 1rem;
		}

		&.small {
			font-size: 1rem;
			font-weight: 700;
		}

		strong {
			font-weight: 600;
		}
	}

	.verification-code {
		position: relative;

		.form-control.form-control-code {
			width: 220px;
			display: block;
			letter-spacing: 13px;
			font-size: 2.25rem;
			padding-bottom: 0;
			padding-top: 0;
			margin: 0 auto 1rem auto;
			text-align: center;
		}
	}

	.btn-link {
		font-weight: bold;
		color: #F37021;
		border: none;
		margin: 0;
		padding: 0;
		outline: none;
		text-decoration: none;
		font-size: 1rem;
	}

	hr {
		margin: 3rem 0;
		opacity: 0.15;

		@media (max-width: 767px) {
			margin: 2rem 0;
		}
	}
}
</style>